import React, { Fragment } from 'react';
import { Card } from 'reactstrap';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { gql } from 'apollo-boost';
import ProductLotsCard from './productLotsCard';
import UserFullname from '~/components/userFullname/userFullname';

export const getProductCompletedLotsQuery = gql`
  query product($id: Int!) {
    product(id: $id) {
      id
      completedLots {
        id
        volume
        permitNumber
        dutyPaid
        reference
        startDate
        completedAt
        startedByUser {
          id
          firstName
          lastName
        }
        completedByUser {
          id
          firstName
          lastName
        }
      }
    }
  }
`;

const CompletedLots = ({ lots }) => (
  <Card>
    {lots.map(lot => {
      const {
        id,
        volume,
        reference,
        startDate,
        completedAt,
        startedByUser,
        completedByuser,
        dutyPaid,
        permitNumber
      } = lot;

      return (
        <div key={id} className="bb-divider pa3 flex">
          <div className="flex-grow-1">
            <p className="f5">
              <Link to={`/lots/${id}`}>{reference}</Link>
              {permitNumber ? <em>({permitNumber})</em> : null}
            </p>
            <p>
              Duty has {!dutyPaid && <strong>NOT </strong>}
              been paid
            </p>
            <p>
              Started on {moment(startDate).format('dddd Do MMMM')} by <UserFullname user={startedByUser} />
            </p>
            <p>
              Completed on {moment(completedAt).format('dddd Do MMMM')}{' '}
              {!!completedByuser && (
                <Fragment>
                  {' '}
                  by <UserFullname user={completedByuser} />
                </Fragment>
              )}
            </p>
          </div>
          <div>
            <p>Volume: {volume}L</p>
          </div>
        </div>
      );
    })}
  </Card>
);

const ProductCompletedLotsCard = props => (
  <ProductLotsCard
    {...props}
    query={getProductCompletedLotsQuery}
    queryKey="completedLots"
    render={CompletedLots}
    title="Completed lots
"
  />
);

export default ProductCompletedLotsCard;



// WEBPACK FOOTER //
// ./src/containers/productLotsCard/completed.jsx